import React, { Component } from 'react';

export default class Head extends Component {
	render() {
		return <div style={{}}>
			<img src={require('./img/logo.jpg')} style={{
				position:"absolute",
				left: (360 - 200)/2,
				top: 100,
				width:200,
				height:200
			}} />
			<div style={{
				position:"absolute",
				left: (360 - 90)/2,
				top: 420,
				width:90,
				height:40,
				backgroundColor:global.blue,
				display:"flex",
				justifyContent:"center",
				alignItems:"center",
				cursor:"pointer"
			}} onClick={global.nextStage}>
				<span style={{
					color:"white"	
				}}>LET'S GO</span>
			</div>
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/Comp/LetGo.js